import { Add, Remove } from "@material-ui/icons";
import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { CustomIcon } from "..";
import quantitySelectorStyles from "./QuantitySelector.styles";
import { borderColor, getCurrentAccentTextColor } from "../../../utils/styles";
import clsx from "clsx";

interface CustomProps {
  value: number;
  addIconColor?: boolean;
  subtractIconColor?: boolean;
  handleAdd: Function;
  handleSubtract: Function;
  loader?: boolean;
  applyBrandColors?: boolean;
}

function QuantitySelector(props: CustomProps) {
  const classes = quantitySelectorStyles();
  const subtractIconColor =
    props.subtractIconColor || props.loader
      ? {
          color: props.applyBrandColors
            ? getCurrentAccentTextColor()
            : borderColor,
        }
      : {};
  const addIconColor =
    props.addIconColor || props.loader
      ? {
          color: props.applyBrandColors
            ? getCurrentAccentTextColor()
            : borderColor,
        }
      : {};

  return (
    <Grid
      container
      className={clsx(classes.selectorContainer, {
        [classes.accentColorBorder]: props.applyBrandColors,
      })}
    >
      <Grid item xs={3} sm={3} md={3} lg={3}>
        <CustomIcon
          icon={<Remove />}
          onClick={props.handleSubtract}
          customClass={clsx(classes.cursor, {
            [classes.opacity]: props.applyBrandColors,
          })}
          {...subtractIconColor}
        />
      </Grid>
      <Grid item xs={6} sm={6} md={6} lg={6}>
        <Typography className={classes.numText}>{props.value}</Typography>
      </Grid>
      <Grid item xs={3} sm={3} md={3} lg={3}>
        <CustomIcon
          icon={<Add />}
          onClick={props.handleAdd}
          customClass={clsx(classes.cursor, {
            [classes.opacity]: props.applyBrandColors,
          })}
          {...addIconColor}
        />
      </Grid>
    </Grid>
  );
}

export default QuantitySelector;
